module.exports = __webpack_public_path__ + "static/loading-36503cc19464adb6ad9bf79e25de2f88.svg";